export const calculatePriceBasedOnFat = (animalType, fat) => {
  if (!fat) return "";

  let price = 0;
  let fatValue = parseFloat(fat);

  // Adjust fat value if it is greater than 13 (e.g., user types 35 instead of 3.5)
  if (fatValue > 13) {
    fatValue /= 10;
  }

  if (animalType === "cow") {
    const cowFatPrices = localStorage.getItem("Cow_fatPrices");
    if (!cowFatPrices) return "0.00";

    const parsedPrices = JSON.parse(cowFatPrices);
    const priceBelow35 = parsedPrices.below35;
    const priceAbove35 = parsedPrices.above35;

    if (fatValue < 3.5) {
      price = (priceBelow35 * fatValue) / 10;
    } else {
      price = (priceAbove35 * fatValue) / 10;
    }
  } else {
    const buffaloFatPrices = localStorage.getItem("Buffalo_fatPrices");
    if (!buffaloFatPrices) return "0.00";

    const parsedPrices = JSON.parse(buffaloFatPrices);
    const priceOn100 = parsedPrices.fat100;
    price = (priceOn100 / 10) * fatValue;
  }

  return price.toFixed(2);
};


export const calculatePriceBasedOnFatAndSNF = (animalType, fat, snf) => {
  if (!fat || !snf) return ""; 
  
  let fatValue = parseFloat(fat);
  let snfValue = parseFloat(snf);

  // Adjust values if user forgets the decimal (e.g., typing 85 instead of 8.5)
  // Kept threshold at 15 to safely avoid modifying actual high SNF/FAT values
  if (fatValue > 15) fatValue /= 10;
  if (snfValue > 15) snfValue /= 10;

  // Map the input to the exact array index generated by AnimalPriceGrid
  // (Value - Starting Point) / 0.1 Step
  const fatIndex = Math.round((fatValue - 3.5) / 0.1);
  const snfIndex = Math.round((snfValue - 7.0) / 0.1);

  // Ensure values don't fall below the minimums of your matrix
  if (fatIndex < 0 || snfIndex < 0) return "0.00"; 

  // NOTE: Ensure this matches the EXACT 'tableTitle' prop you pass to AnimalPriceGrid
  const localStorageKey = animalType === "cow" ? "Cow" : "Buffalo";
  
  const storedData = localStorage.getItem(localStorageKey);
  if (!storedData) {
    return "0.00";
  }
  
  const storedPrices = JSON.parse(storedData);

  // Verify the calculated indices actually exist within the array bounds
  if (
    storedPrices &&
    storedPrices.length > snfIndex && 
    storedPrices[snfIndex] &&
    storedPrices[snfIndex].length > fatIndex 
  ) {
    const price = parseFloat(storedPrices[snfIndex][fatIndex]) || 0;
    return price.toFixed(2);
  }

  return "0.00";
};